// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Navigate } from 'react-router';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import WebService from '../Services/WebService';
export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: any;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
}: ProtectedRouteProps) {
  return outlet;
}
